<template>
  <div class="xydialog-wrap">
      <el-dialog :visible.sync="show" title="注册协议和隐私政策" center width="800px">
          <div class="m-content" v-html="content"></div>
      </el-dialog>
  </div>
</template>

<script lang="ts">
export default {
    data(){
        return {
          show:false,
          content:''
        }
    },
    created(){
        this.getDetailFun()
    },
    methods:{
        open(){
            this.show = true
        },
        getDetailFun(){
            this.$http.get('index_getUserAgreement',{}).then(res=>{
                if(res.code == 1){
                    this.content = res.data.xieyi
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.m-content{
    font-size: 14px;
    color: #333;
    line-height: 24px;
}
</style>
